/**
 * Global colors constants and helpers based on Vuetify Material Colors:
 * https://vuetifyjs.com/en/style/colors#material-colors
 */
import vcolors from 'vuetify/lib/util/colors'

/**
 * Usage:
 *    import COLORS from "@/util/colors"
 *      let hexVar = COLORS.hex.solar
 */

/**
 * Artcile discussing best colors for visualizations
 * @see: http://www.thisprogrammingthing.com/2014/optimal-colors-for-graphsin-rgb-hex/
 */
let hex = Object.freeze({
  /**
   * Theme
   */
  primary: '#335b98',
  secondary: '#29B6F6',

  /**
   * General
   */
  black: vcolors.shades.black,
  white: vcolors.shades.white,
  grey: vcolors.grey.lighten1,

  /**
   * Function / Feature
   */
  crosshairs: vcolors.blueGrey.lighten4,
  rampUp: vcolors.lightGreen.darken1, //vcolors.cyan.darken2,
  rampDown: vcolors.orange.base,
  run: vcolors.indigo.base,
  tooltip: vcolors.grey.lighten3,

  /**
   * Data 'Types'
   */
  time: vcolors.lightBlue.accent3,

  power: '#396AB1',
  load: '#3E9651',
  value: '#CC2529',
  unrealized: '#DA7C30',
  actual: '#6B4C9A',
  actualValue: '#880E4F',
  loss: '#808585',

  cost: vcolors.green.base,
  threshold: vcolors.amber.darken2,

  /**
   * Components
   */
  solar: vcolors.yellow.base,
  cogen: '#AB6857'
})

/**
 * Shade a color
 */
let shades = Object.freeze({
  light(hex) {
    return this.rgb(hex, 0.3)
  },
  medium(hex) {
    return this.rgb(hex, 0.5)
  },
  dark(hex) {
    return this.rgb(hex, 0.8)
  },
  rgb(hex, opacity) {
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      let c = hex.substring(1).split('')
      if (c.length == 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]]
      }
      c = '0x' + c.join('')
      return (
        'rgba(' +
        [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') +
        ',' +
        opacity +
        ')'
      )
    }
    throw new Error('Bad Hex')
  }
})

export default {
  hex: hex,
  shades: shades
}
